import { gql } from '@apollo/client';
import { FRAGMENT_PRODUCT_REVIEW } from './fragments';

const FRAGMENT_REVIEW = gql`
  fragment FragmentReview on Review {
    id
    review
    traveller
    rating
    date
    source
    published_at
    cities {
      id
      name
      slug
    }
  }
`;

const FRAGMENT_REVIEW_AGGREGATE = gql`
  fragment FragmentReviewAggregate on ReviewConnection {
    aggregate {
      count
      totalCount
      avg {
        rating
      }
    }
    groupBy {
      rating {
        key
        connection {
          aggregate {
            count
            totalCount
          }
        }
      }
    }
  }
`;
export const FETCH_REVIEW_AGGREGATE_TOURS = gql`
  query FETCH_REVIEW_AGGREGATE($id: Int!) {
    strapi_reviews_aggregate(where: { product: { _eq: $id } }) {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
  }
`;
export const FETCH_REVIEW_COUNTS_BY_RATING = gql`
  query FETCH_REVIEW_COUNTS_BY_RATING($id: Int!) {
    strapi_reviews(where: { product: { _eq: $id } }) {
      rating
    }
  }
`;

const CHECK_EXISTING_REVIEW_BY_BOOKING_ID = gql`
  query CHECK_EXISTING_REVIEW_BY_BOOKING_ID($bookingId: String!) {
    strapi_reviews(where: { booking_id: { _eq: $bookingId } }) {
      id
      booking_id
      traveller
      rating
      created_at
    }
  }
`;

const INSERT_REVIEW = gql`
  mutation INSERT_REVIEW($data: ReviewInput) {
    createReview(input: { data: $data }) {
      review {
        ...FragmentReview
      }
    }
  }
  ${FRAGMENT_REVIEW}
`;
export const INSERT_IMAGE_REVIEW = gql`
  mutation InsertImageReview(
    $title: String
    $review: String
    $traveller: String
    $rating: numeric
    $date: timestamptz
    $source: String
    $product: Int
    $published_at: timestamptz
    $created_at: timestamptz
    $updated_at: timestamptz
    $city: Int
    $image_urls: jsonb
    $booking_id: String
  ) {
    insert_strapi_reviews_one(
      object: {
        title: $title
        review: $review
        traveller: $traveller
        rating: $rating
        date: $date
        booking_id: $booking_id
        source: $source
        product: $product
        published_at: $published_at
        created_at: $created_at
        updated_at: $updated_at
        city: $city
        image_urls: $image_urls
      }
    ) {
      id
      review
      traveller
      rating
    }
  }
`;
const FETCH_REVIEWS = gql`
  query FETCH_REVIEWS(
    $limit: Int
    $offset: Int
    $order_by: [strapi_reviews_order_by]
    $cityObject: JSON
    $where: strapi_reviews_bool_exp
  ) {
    strapi_reviews(
      limit: $limit
      offset: $offset
      where: $where
      order_by: $order_by
    ) {
      id
      title
      review
      traveller
      rating
      date
      source
      created_at
      published_at
      product
      image_urls
      parentproduct {
        name
        slug
      }
      city
    }
    reviewsConnection(where: $cityObject) {
      ...FragmentReviewAggregate
    }
  }
  ${FRAGMENT_REVIEW}
  ${FRAGMENT_REVIEW_AGGREGATE}
`;

const CITIES_PRODUCT_FILTER = gql`
  query CITIES_FILTER($filter: JSON!) {
    cities(where: $filter) {
      name
      allThings: all_things_to_do {
        product {
          ...FRAGMENT_PRODUCT_REVIEW
        }
      }
      dayTours: day_tours {
        product {
          ...FRAGMENT_PRODUCT_REVIEW
        }
      }
      multiday: multi_day_tours {
        product {
          ...FRAGMENT_PRODUCT_REVIEW
        }
      }
    }
  }
  ${FRAGMENT_PRODUCT_REVIEW}
`;

const CITIES_DROPDOWN = gql`
  query CITIES_PAGE {
    citiesPage {
      featured: featured_cities {
        city {
          id
          name
          slug
        }
      }
      cities: all_cities {
        city {
          id
          name
          slug
        }
      }
    }
  }
`;

const FETCH_PRODUCTS = gql`
  query FETCH_PRODUCTS {
    products {
      id
      name
      slug
    }
    cities {
      id
      name
      slug
    }
  }
`;
export const FETCH_GOOGLE_STATS = gql`
  query FETCH_GOOGLE_STATS($id: uuid!) {
    boatnew_organizations_stats_by_pk(id: $id) {
      id
      google_reviews_rating
      google_reviews_count
    }
  }
`;

export const UPDATE_GOOGLE_STATS = gql`
  mutation UPDATE_GOOGLE_STATS(
    $id: uuid!
    $google_reviews_rating: String!
    $google_reviews_count: String!
  ) {
    update_boatnew_organizations_stats_by_pk(
      pk_columns: { id: $id }
      _set: {
        google_reviews_rating: $google_reviews_rating
        google_reviews_count: $google_reviews_count
      }
    ) {
      id
    }
  }
`;
interface FETCH_PRODUCTS_INTERFACE {
  products: [
    {
      id: string;
      name: string;
      slug: string;
    }
  ];
  cities: [
    {
      id: string;
      name: string;
      slug: string;
    }
  ];
}
interface FETCH_REVIEWS_INTERFACE {
  strapi_reviews: [
    {
      id: string;
      title: string;
      review: string;
      traveller: string;
      rating: number;
      date: string;
      created_at: string;
      source: string;
      product: number;
      parentproduct: {
        name: string;
        slug: string;
      };
      city: number;
    }
  ];
  reviewsConnection: {
    aggregate: {
      count: number;
      totalCount: number;
      avg: {
        rating: number;
      };
    };
    groupBy: {
      rating: [
        {
          key: number;
          connection: {
            aggregate: {
              count: number;
              totalCount: number;
            };
          };
        }
      ];
    };
  };
}
interface CITIES_DROPDOWN_INTERFACE {
  citiesPage: {
    featured: [
      {
        city: {
          id: string;
          name: string;
          slug: string;
        };
      }
    ];
    cities: [
      {
        city: {
          id: string;
          name: string;
          slug: string;
        };
      }
    ];
  };
}
export {
  FETCH_REVIEWS,
  FETCH_PRODUCTS,
  INSERT_REVIEW,
  FRAGMENT_REVIEW,
  CITIES_PRODUCT_FILTER,
  CITIES_DROPDOWN,
  CHECK_EXISTING_REVIEW_BY_BOOKING_ID
};
export type {
  FETCH_REVIEWS_INTERFACE,
  FETCH_PRODUCTS_INTERFACE,
  CITIES_DROPDOWN_INTERFACE
};
